<template>
  <div class="order-confirm-footer">
    <div class="footer-body">
      <div class="left-box">
        <div class="pay-price">
          <div class="price-label">应付金额</div>
          <div class="price-num">
            <span class="currency">¥</span>
            <number-animation class="price" :value="totalAmount / 100"></number-animation>
            <!-- <base-price-text
              :price="totalAmount"
              :styleOption="{
                currency: 'font-size: 16px;line-height:18px;margin-right: 2px;',
                integer: 'font-size: 24px;line-height:22px;',
                decimal: 'font-size: 20px;',
              }"
            ></base-price-text> -->
          </div>
        </div>
        <div class="balance-box">
          <div class="balance-label">可用余额</div>
          <div class="balance-value">
            <base-price-text
              color="#2F333D"
              :price="peer.balance_amount"
              :styleOption="{
                currency: 'font-size: 14px;line-height:15px;margin-right: 2px;',
                integer: 'font-size: 16px;line-height:14px;',
                decimal: 'font-size: 12px;',
              }"
            ></base-price-text>
          </div>
          <div class="recharge-btn-box">
            <div class="recharge-btn" @click="showRechargeDialog">
              <div>充值</div>
              <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/confirm/confirm-icon-right.png" alt="">
            </div>
          </div>

        </div>
      </div>
      <div class="right-box">
        <!-- 立即支付按钮 -->
        <el-button type="primary" :disabled="loading" class="pay-button" @click="onPay">
          立即支付
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import productService from '@/services/product-service';
import User from '@/libs/user';
import sensorsdata from 'sa-sdk-javascript';
import BasePriceText from './base/base-price-text.vue';
import NumberAnimation from '@/components/common/animation/number-animation.vue';

export default {
  components: { BasePriceText, NumberAnimation },
  props: {
    order: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    peer: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    totalAmount: {
      type: Number,
    },
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      productService,
    };
  },
  computed: {},
  created() {},
  methods: {
    showRechargeDialog() {
      sensorsdata.track('Recharge_voucher', {
        peer_name: User.peer.peer_name,
        visa_peer_id: User.peer.visa_peer_id || '',
        platform_type: 'PC',
        page_from: '支付页-底部充值',
      });
      this.$emit('handleShowRechargeDialog');
    },
    onPay() {
      this.$emit('pay');
    },
  },
};
</script>

<style lang="less" scoped>
.order-confirm-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  height: 104px;
  background: #FFFFFF;
  box-shadow: 0px -2px 8px 0px rgba(0,0,0,0.06);
  z-index: 10;
  line-height: 1;
  .footer-body {
    margin: 0 auto;
    width: 1200px;
    height: 100%;
    padding-right: 320px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left-box {
      .pay-price {
        display: flex;
        align-items: center;
        .price-label {
          color: #2F333D;
          font-size: 20px;
          font-weight: 600;
          margin-right: 12px;
        }

        .price-num {
          color: #FF8033;
          font-weight: 600;
          line-height: 20px;
          font-family: Arial;
          line-height: 1;
          display: flex;
          align-items: flex-end;
          .currency{
            margin-bottom: 2px;
            font-size: 16px;
            margin-right: 4px;
          }
          .price{
            font-size: 24px;
          }

        }
      }

      .balance-box {
        margin-top: 12px;
        display: flex;
        align-items: flex-end;
        .balance-label {
          color: #5F666E;
          font-size: 16px;
          margin-right: 8px;
        }

        .balance-value {
          color: #2F333D;
          font-weight: 600;
        }

        .recharge-btn-box {
          margin-left: 8px;
          border-left: 1px solid #C0DAFF;
          height: 14px;
          display: flex;
          align-items: center;
          padding: 8px;
          .recharge-btn{
            color: #599FFF;
            font-size: 16px;
            cursor: pointer;
            font-weight: 600;
            display: flex;
            align-items: center;
            .icon{
              width: 17px;
              height: 16px;
              margin-left: 4px;
              margin-bottom: 3px;
            }
          }
        }
      }
    }

    .right-box {
      .pay-button {
        width: 272px;
        height: 50px;
        background: #FF8033;
        border-radius: 2px;
        border: none;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        &.is-disabled{
          background:rgba(255,128,51,0.7);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-confirm-footer.vue